import { STOCK_TAKING_CAR_MANAGEMENT_SET_MAIN_FILTER_DATA } from './constants'

export function setMainFilterData( args={} ) {
  return dispatch => {
    dispatch({
      type: STOCK_TAKING_CAR_MANAGEMENT_SET_MAIN_FILTER_DATA,
      data: {args}
    })
  }
}

export function reducer(state, action) {
  if (action.type === STOCK_TAKING_CAR_MANAGEMENT_SET_MAIN_FILTER_DATA) {
      return {
        ...state,
        takingCarManagement : {
          ...state.takingCarManagement,
          mainFilterData: {
            ...state.takingCarManagement.mainFilterData,
            ...action.data.args
          }
        }
      }
  }
  else{
      return state
  }  
}